import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ProductFilterChangedEvent} from './product-filter-changed-event';
import {CategoriesService} from '../../api/categories.service';
import {FilterStorageService} from '../../services/filter-storage.service';
import {BrandViewModel} from './brand-view-model';
import {CategoryViewModel} from './category-view-model';

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss']
})
export class ProductFilterComponent implements OnInit {
  @Output()
  filtersChanged: EventEmitter<ProductFilterChangedEvent> = new EventEmitter<ProductFilterChangedEvent>();
  public brands: BrandViewModel[] = [];
  private allCategories: CategoryViewModel[] = [];
  public visibleCategories: CategoryViewModel[] = [];
  public selectedBrand: BrandViewModel;
  public selectedCategory: CategoryViewModel;

  constructor(
    private categoryApi: CategoriesService,
    private filters: FilterStorageService
  ) { }

  async ngOnInit() {
    const categoryListPromise = this.categoryApi.get(this.filters.getSelectedOrganization().id).toPromise();
    const mainCategoryListPromise = this.categoryApi.getMain().toPromise();

    const promiseResult = await Promise.all([categoryListPromise, mainCategoryListPromise]);

    const categoryList = promiseResult[0];
    const mainCategoryList = promiseResult[1];

    const brands: Map<string, BrandViewModel> = new Map<string, BrandViewModel>();

    const activeCategories = categoryList
      .data
      .filter(x => x.state === 'A');

    const categoryVms: CategoryViewModel[] = [];

    for (const c of activeCategories) {
      if (!brands.has(c.brandID)) {
        const mainCategory = mainCategoryList.data.filter(x => x.id === c.baseID)[0];

        if (mainCategory == null) {
          console.error('main category is not found for', c);
          continue;
        }

        brands.set(c.brandID, new BrandViewModel(c.brandID, mainCategory.brandName));
      }

      categoryVms.push(new CategoryViewModel(c));
    }

    this.brands = Array.from(brands.values()).sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }
      if (b.name > a.name) {
        return -1;
      }
      return 0;
    });
    console.log(this.brands, brands);
    this.allCategories = categoryVms.sort((a, b) => {
      if (a.category.name > b.category.name) {
        return 1;
      }
      if (b.category.name > a.category.name) {
        return -1;
      }
      return 0;
    });

    this.selectBrand(this.brands[0]);
  }

  public resetFilters() {
    this.selectedBrand = null;
    this.selectedCategory = null;
    this.filtersChanged.emit(new ProductFilterChangedEvent(null));
  }

  selectBrand(o: BrandViewModel) {
    this.selectedBrand = o;
    this.visibleCategories = this.allCategories.filter(x => x.category.brandID === o.id);

    this.selectCategory(this.visibleCategories[0]);
  }

  selectCategory(o: CategoryViewModel) {
    this.selectedCategory = o;
    this.filtersChanged.emit(new ProductFilterChangedEvent(o.category.id));
  }
}
